import { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// GET Request Schemas //
// Endpoint: /api/create-quote/unit-types
export const unitTypeSchema = idNameSchema.extend({
	code: z.string(),
});

export type UnitType = z.infer<typeof unitTypeSchema>;
